import React from 'react';
import { Helmet } from 'react-helmet-async';

const PerformanceOptimizations: React.FC = () => {
  return (
    <Helmet>
      {/* Preconnect vers les domaines critiques */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link rel="preconnect" href="https://analytics.ahrefs.com" />

      {/* DNS Prefetch pour les domaines secondaires */}
      <link rel="dns-prefetch" href="https://www.google-analytics.com" />
      <link rel="dns-prefetch" href="https://vitals.vercel-insights.com" />

      {/* Optimisations Core Web Vitals */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="theme-color" content="#1e3a5f" />
    </Helmet>
  );
};

export default PerformanceOptimizations; 